import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';
import { FormLabel } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function DuracionSemanasUmmIApps() {
    const { promptData, setPromptData } = useActividadesContext();
    const [value, setValue] = React.useState(promptData.cantidad_de_semanas || 8);

    // Maneja cambios de la cantidad de semanas
    const handleSemanaChange = (nuevaCantidadSemanas) => {
        setPromptData((prevPromptData) => ({
            ...prevPromptData,
            cantidad_de_semanas: nuevaCantidadSemanas,
        }));
    };

    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
        handleSemanaChange(newValue);
    };

    const handleInputChange = (event) => {
        const newValue = event.target.value === '' ? 1 : Number(event.target.value);
        setValue(newValue);
        handleSemanaChange(newValue);
    };

    const handleBlur = () => {
        if (value < 1) {
            setValue(1);
            handleSemanaChange(1);
        } else if (value > 20) {
            setValue(20);
            handleSemanaChange(20);
        }
    };

    return (
        <Box sx={{ width: '90%', m: 5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', pb: 1 }}>
                <Typography sx={{ fontFamily: 'Inter', fontSize: '1.25rem', fontWeight: 'bold' , color: '#336B87' }}>
                    Cantidad de semanas *
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'Inter', fontSize: '0.85rem', mt: 0.2 }}>
                    Selecciona el total de semanas que debe cubrir esta planificación.
                </FormLabel>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs>
                    <Slider
                        value={typeof value === 'number' ? value : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                        color="success"
                        sx={{ color: '#336B87' }}
                        valueLabelDisplay="auto"
                        defaultValue={8}
                        min={1}
                        max={20}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography
                            variant="body2"
                            sx={{ cursor: 'pointer', fontSize: '0.6rem' }}
                        >
                            1 semana
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ cursor: 'pointer', fontSize: '0.6rem' }}
                        >
                            20 semanas
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Input
                        value={value}
                        size="small"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        inputProps={{
                            step: 1,
                            min: 1,
                            max: 20,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                    <Typography sx={{ fontSize: '0.6rem' }}>Semanas</Typography>
                </Grid>
            </Grid>
        </Box>
    );
}
